module.exports = require('./helpers/bundle-url').getBundleURL('1suA6') + "logo.c51670a8.svg";